var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSecureSite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_29607_5010)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.775 2.85365L16.4217 0.0683211C16.1482 -0.0227737 15.8525 -0.0227737 15.579 0.0683211L7.22566 2.85365C5.89753 3.29483 4.74221 4.14333 3.92385 5.2786C3.10549 6.41387 2.66571 7.77817 2.66699 9.17765V16.0003C2.66699 26.0843 14.9337 31.6537 15.459 31.8857C15.6294 31.9614 15.8138 32.0005 16.0003 32.0005C16.1868 32.0005 16.3712 31.9614 16.5417 31.8857C17.067 31.6537 29.3337 26.0843 29.3337 16.0003V9.17765C29.3349 7.77817 28.8952 6.41387 28.0768 5.2786C27.2584 4.14333 26.1031 3.29483 24.775 2.85365Z",
    fill: "#F1EBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4001 11.0668L14.8161 16.6668L11.824 13.5468C11.704 13.4155 11.5588 13.3096 11.3972 13.2352C11.2356 13.1609 11.0607 13.1197 10.8828 13.114C10.705 13.1083 10.5279 13.1382 10.3618 13.2021C10.1957 13.2659 10.0441 13.3623 9.91588 13.4857C9.78765 13.609 9.6854 13.7567 9.61516 13.9202C9.54491 14.0837 9.50809 14.2595 9.50687 14.4374C9.50564 14.6153 9.54003 14.7917 9.60802 14.9561C9.676 15.1205 9.7762 15.2697 9.90272 15.3948L12.9774 18.5948C13.2067 18.8424 13.4838 19.041 13.7921 19.1785C14.1003 19.316 14.4332 19.3896 14.7707 19.3948H14.8147C15.1455 19.3959 15.4731 19.3312 15.7787 19.2047C16.0842 19.0781 16.3616 18.8921 16.5947 18.6574L22.2907 12.9614C22.4151 12.8373 22.5139 12.6899 22.5813 12.5276C22.6487 12.3653 22.6835 12.1913 22.6837 12.0155C22.6839 11.8398 22.6495 11.6657 22.5824 11.5033C22.5153 11.3408 22.4169 11.1932 22.2927 11.0688C22.1686 10.9444 22.0211 10.8456 21.8588 10.7782C21.6965 10.7108 21.5225 10.676 21.3468 10.6758C21.171 10.6756 20.997 10.71 20.8345 10.7771C20.6721 10.8442 20.5245 10.9426 20.4001 11.0668Z",
    fill: "#C9B3FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_29607_5010"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecureSite);
export default __webpack_public_path__ + "static/media/secure-site.8f2772b1784b4d7c44ec5348e5e4e20c.svg";
export { ForwardRef as ReactComponent };